import type { AxiosWrapper } from '../axiosWrapper';
import type { ApiMiddleware, ApiResponse, AxiosExtendedRequestConfig } from '../types';

export class RestApiClient {
    public constructor(protected axiosWrapper: AxiosWrapper, middlewares?: ApiMiddleware[]) {
        middlewares?.forEach(middleware => this.axiosWrapper.addMiddleware(middleware));
    }

    public request<T>(requestConfig: AxiosExtendedRequestConfig): Promise<ApiResponse<T>> {
        return this.axiosWrapper.request(requestConfig);
    }

    public getAxiosWrapper(): AxiosWrapper {
        return this.axiosWrapper;
    }
}
